<script>
import { ref } from 'vue'
import { debounce } from 'lodash'
import { useStore } from '../../store'

export default {
  setup(props, { slots }) {
    const store   = useStore()
    const loading = ref(false)
    const active  = ref(false)
    const toggle  = () => active.value = ! active.value
    
    const onAddToCart = (variation) => {
      loading.value = true
      store.storeAJAX({
        method: 'post',
        url: '/cart/add.js',
        data: {
          items: [{
            id : parseInt( variation ),
            quantity : 1
          }]
        },
        dataType: 'json'
      })
        .then((response) => {
          store.getCart()
          store.drawers.cart = true
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          loading.value = false
        })
    }

    return () => slots.default({
      loading: loading.value,
      active: active.value,
      toggle,
      addToCart: debounce((variation) => onAddToCart(variation), 500)
    })
  }
}
</script>